// Kopi av et salgsdokument, som utkast i editoren — ikke i databasen.
//
// «Lag kopi» lagret tidligere kopien med en gang, og salgsflyten har i tillegg
// en egen «Lagre utkast»-knapp. Bruker man begge, som er den naturlige
// rekkefolgen, endte man med to utkast for samme dokument. Kopien lages derfor
// lokalt her, og blir forst et utkast i lista naar brukeren selv lagrer den.
//
// Feltene under er de som hoerer til det opprinnelige dokumentet og ikke til
// kopien: nummer, sending, betaling, delingslenker, aksept og PDF. Lista
// speiler `cleanInvoiceCopy` i functions/accounting/invoiceMutationHttp.ts, som gjor
// det samme naar backend kopierer.
(function initInvoiceDraftCopy(global) {
  const DROPPED_FIELDS = [
    'updatedAt',
    'sentAt',
    'paidAt',
    'paidBy',
    'publicViewToken',
    'publicViewedAt',
    'publicViewEvents',
    'publicLinkGeneratedAt',
    'offerAcceptanceToken',
    'offerAcceptedAt',
    'offerAcceptedSource',
    'offerAcceptedByEmail',
    'orderConfirmationSentAt',
    'creditedFromInvoiceId',
    'convertedFromInvoiceId',
    'archivedAt',
    'sendEvents',
    'pdfStoragePath',
    'pdfDownloadUrl',
    'pdfFileName',
    'pdfMimeType',
    'pdfGeneratedAt',
    'pdf',
  ];

  const draftCopy = (invoice, options = {}) => {
    if (!invoice) return null;
    const newId = String(options.newId || '');
    const now = String(options.now || '');
    const copy = { ...invoice };
    DROPPED_FIELDS.forEach((field) => { delete copy[field]; });
    copy.id = newId;
    copy.invoiceNumber = '';
    copy.status = 'draft';
    // `invoiceType` finnes bare paa eldre dokumenter. Er den der, skal den folge
    // med som utkast; er den det ikke, skal kopien ikke faa den plutselig.
    if (invoice.invoiceType !== undefined) copy.invoiceType = 'draft';
    copy.createdAt = now;
    copy.lines = (Array.isArray(invoice.lines) ? invoice.lines : [])
      .map((line, index) => ({ ...line, id: `${newId}-line-${index + 1}` }));
    if (options.kind) copy.kind = options.kind;
    if (options.convertedFromInvoiceId) copy.convertedFromInvoiceId = options.convertedFromInvoiceId;
    return copy;
  };

  global.PlummeInvoiceDraftCopy = { draftCopy, DROPPED_FIELDS };
})(typeof window !== 'undefined' ? window : globalThis);
